import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, CircularProgress, Fab } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useValue } from '../../../context/ContextProvider';
import { borrarMarca } from '../../../actions/marcas';

const MarcasActions = ({ params, rowId, setRowId, deleteRow }) => {
    const [loading, setLoading] = useState([false, false]); //Maneja el estado del circulo de espera en el icono seleccionado
    const [success, setSuccess] = useState(false);          //Si es true pone el icono de success, de otro modo pone el icon de grabar    
    const [rowState, setRowState] = useState(false);        //Activa o desactiva el icono de grabar
    const { state: { currentUser, marcas, okCancelDialog }, dispatch } = useValue();     //sirve para actualizar la tabla usuarios en borrado de registros
    const [okCancelValue, setOkCancelValue] = useState(null);

    const { id, marca } = params.row;

    useEffect(() => {
        if (params.id == rowId) {
            setRowState(true);
            setSuccess(false);
        }
        if (okCancelValue) {
            //console.log('Respuesta de okCancelDialog: ', okCancelValue, 'id', id);
            if (okCancelValue.resp === 'ACEPTAR')
                handleDelete(okCancelValue);
            setOkCancelValue(null);
            //dispatch({ type: 'UPDATE_OKCANCEL', payload: { open: false, title: null, message: null, respuesta: null, callerData: null} });
        }
    }, [rowId, okCancelValue])

    const handleDelete = async (okCancelValue) => {
        setLoading([false, true]);
        try {
            //console.log('handleDelete');

            const result = await borrarMarca({ cmd: 'CMD_DELETE', idToDelete: id }, currentUser, dispatch);
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Marca eliminada." } });

            const newMarcas = marcas.filter((marca) => marca.id !== id);
            //console.log({ newMarcas })
            dispatch({ type: 'UPDATE_MARCAS', payload: { rows: newMarcas } });  //A users se envía el payload como {rows: valor}
        } catch (error) {

        }
        setLoading([false, false]);
    }

    const handleSubmit = async (comando) => {




        //const {id} = params.row;
        //console.log('RowId: ', rowId);
        //console.log('NewRow: ', params.row);
        let result = null;
        const { row, table } = params.row;



        if (comando === 'CMD_UPDATE') {
            //console.log('USERS CMD: ', comando);

            setLoading([true, false]);
            //result = await updateUser({cmd: 'CMD_UPDATE', id, name, email, tipoUsuario, habilitado }, currentUser, dispatch);
            setRowId(null);
            setRowState(false);
            setSuccess(true);
            setLoading([false, false]);
            /*setTimeout(() => {
                console.log("Delayed for 3 second.");
                setSuccess(false);
              }, "3000");
            */
        }

        if (comando === 'CMD_DELETE') {
            //console.log('USERS CMD: ', comando);
            dispatch({ type: 'UPDATE_OKCANCEL', payload: { open: true, funcion: setOkCancelValue, title: 'Confirmar borrar', message: `Está seguro de borrar la marca "${marca}" (Id: ${id})?`, respuesta: null, callerData: id } });
        }
    }


    return (
        <>
            <Box
                sx={{
                    m: 1,
                    position: 'relative',
                }}
            >
                <Fab

                    sx={{
                        width: 36,
                        height: 36,
                        boxShadow: 0,
                        bgcolor: '#E0E0E0',
                        color: '#A6A6A6',
                        '&:hover': { color: '#FFF', bgcolor: 'red', boxShadow: 1 }
                    }}
                    onClick={() => handleSubmit('CMD_DELETE')}
                >
                    <CancelIcon />
                </Fab>
                {loading[1] && (
                    <CircularProgress
                        size={48}
                        sx={{
                            color: 'red',
                            position: 'absolute',
                            top: -4,
                            left: -4,
                            zIndex: 1
                        }}
                    />
                )}
            </Box>
        </>
    )
}

export default MarcasActions